import * as React from 'react'

import { ReactComponent, Subtract } from '../../types'
import { httpStatusMap }            from '../../utils'

export interface InjectedWithCommunicationProps {
  fetching: boolean
  success: boolean
  error: string

  onCommunicationInitiation: () => void
  onCommunicationError: (httpErrorResponse: Response) => void
  onCommunicationSuccess: () => void
}

const initState = {
  fetching: false,
  success:  false,
  error:    '',
}

function withCommunication<BaseProps extends InjectedWithCommunicationProps> (
  Component: ReactComponent<BaseProps>
) {
  type Props = Subtract<BaseProps, InjectedWithCommunicationProps>

  return class extends React.Component<Props, typeof initState> {
    public state = initState

    public render () {
      return (
        <Component
          {...this.state}
          onCommunicationInitiation={this.handleCommunicationInitiation}
          onCommunicationError={this.handleCommunicationError}
          onCommunicationSuccess={this.handleCommunicationSuccess}
          {...this.props}
        />
      )
    }

    private handleCommunicationInitiation = () => {
      this.setState({ fetching: true })
    }

    private handleCommunicationSuccess = () => {
      this.setState(({ success: true, fetching: false }))
    }

    private handleCommunicationError = ({ status }: Response) => {

      this.setState(({
        error:    httpStatusMap[ status ],
        fetching: false,
      }))
    }
  }
}

export default withCommunication



// WEBPACK FOOTER //
// ./src/components/hocs/withCommunication.tsx